import {ActivatedRouteSnapshot} from '@angular/router';
import {EnumLikeType} from '../common-utils';

export module RouteUtils {

  /**
   * Get the value of a route from a snapshot.
   */
  export function routeNameFromSnapshot<RoutesEnumType>(
    route: ActivatedRouteSnapshot,
    routeEnum: EnumLikeType<RoutesEnumType>,
  ): RoutesEnumType | undefined {
    let routeNameStr: string = decodeURI(route.url.join('/'));
    Object.keys(route.params).forEach((param: string) => {
      routeNameStr = routeNameStr.replace(route.params[param] as string, `:${param}`);
    });
    return Object.values(routeEnum).find(
      (routeName: RoutesEnumType) => routeName as string === routeNameStr,
    );
  }

}
